// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/session/activity.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/session/star.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.meetingPage_notes_wrap{
    display: flex;
    flex-direction: column;
    width: 300%;
    justify-content: space-between;
    gap: 17px;
}

.meetingPage_notes{
    width: 100%;
    display: flex;
    gap: 17px;
}

.meetingPage_notes_column{
    width: 100%;
}

.meetingPage_bottom_graphic{
    width: 100%;
}

.meetingPage_note_h{
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: #000000;
    margin-bottom: 12px;
}

.meetingPage_note_ul{
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #000000;
    margin-bottom: 12px;
}

.meetingPage_note_li{
    display: flex;
    align-items: center;
    gap: 8px;
}

.meetingPage_note_li::before{
    content: '';
    background-color: #000000;
    border-radius: 100%;
    width: 4px;
    height: 4px;
    margin-left: 4px;
}


.meetingPage_notes_menu{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
    padding: 20px 0px;
}

.meetingPage_notes_menu_button{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3px 11px;
    gap: 7px;
    height: 22px;

    background: #E2E9FC;
    border-radius: 25px;

    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #000000;
}

.meetingPage_notes_menu_button::before{
    content: '';
    width: 16px;
    height: 16px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}

.meetingPage_notes_menu_button--task::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}`, "",{"version":3,"sources":["webpack://./src/pages/meetingPage/components/meetingPageNotes/MeetingPageNotes.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,QAAQ;IACR,YAAY;;IAEZ,mBAAmB;IACnB,mBAAmB;;IAEnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,yDAAgE;IAChE,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,yDAA4D;AAChE","sourcesContent":[".meetingPage_notes_wrap{\n    display: flex;\n    flex-direction: column;\n    width: 300%;\n    justify-content: space-between;\n    gap: 17px;\n}\n\n.meetingPage_notes{\n    width: 100%;\n    display: flex;\n    gap: 17px;\n}\n\n.meetingPage_notes_column{\n    width: 100%;\n}\n\n.meetingPage_bottom_graphic{\n    width: 100%;\n}\n\n.meetingPage_note_h{\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 18px;\n    color: #000000;\n    margin-bottom: 12px;\n}\n\n.meetingPage_note_ul{\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 14px;\n    color: #000000;\n    margin-bottom: 12px;\n}\n\n.meetingPage_note_li{\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.meetingPage_note_li::before{\n    content: '';\n    background-color: #000000;\n    border-radius: 100%;\n    width: 4px;\n    height: 4px;\n    margin-left: 4px;\n}\n\n\n.meetingPage_notes_menu{\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 20px;\n    padding: 20px 0px;\n}\n\n.meetingPage_notes_menu_button{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 3px 11px;\n    gap: 7px;\n    height: 22px;\n\n    background: #E2E9FC;\n    border-radius: 25px;\n\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    color: #000000;\n}\n\n.meetingPage_notes_menu_button::before{\n    content: '';\n    width: 16px;\n    height: 16px;\n    background-image: url('../../../../assets/session/activity.svg');\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n}\n\n.meetingPage_notes_menu_button--task::before{\n    background-image: url('../../../../assets/session/star.svg');\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
